"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETestData = void 0;
var ETestData;
(function (ETestData) {
    ETestData["TestButtonSignUp"] = "button-sign-up";
    ETestData["TestButtonSignIn"] = "button-sign-in";
    ETestData["TestEvent"] = "event";
    ETestData["TestEventRow"] = "event-row";
    ETestData["TestEventMarketOdd"] = "event-marketOdd";
    ETestData["TestBasketIcon"] = "basket-icon-wrapper";
    ETestData["TestBasketBetType"] = "basket-bet-type";
    ETestData["TestBasketBetCardHoverIcon"] = "basket-bet-card-hover-icon";
    ETestData["TestBasketSwitch"] = "basket-bet-switch";
    ETestData["TestBasketButtonMakeABet"] = "basket-button-make-a-bet";
    ETestData["TestBasketBetCardInput"] = "basket-bet-card-input";
    ETestData["TestBasketButtonSingleBetSize"] = "basket-button-single-bet-size";
    ETestData["TestBasketButtonClearAll"] = "basket-button-clear-all";
    ETestData["TestBasketInputRadioPartly"] = "basket-input-radio-partly";
    ETestData["TestBasketInputRadioAlways"] = "basket-input-radio-always";
    ETestData["TestBasketInputRadioNever"] = "basket-input-radio-never";
    ETestData["TestBasketHistoryItem"] = "basket-history-item";
    ETestData["TestBetsHistoryTabs"] = "bets-history-tabs";
    ETestData["TestBetsHistoryTableTabs"] = "bets-history-table-tabs";
    ETestData["TestBetsHistoryBetsTypeCheckbox"] = "bets-history-bets-type-checkbox";
    ETestData["TestBetsHistoryDatePicker"] = "bets-history-date-picker";
    ETestData["TestBetsHistoryFilterButton"] = "bets-history-filter-button";
    ETestData["TestBetsHistoryFilterTextButton"] = "bets-history-filter-text-button";
    ETestData["TestBetsHistoryClearHistoryButton"] = "bets-history-clear-history-button";
    ETestData["TestBetsHistoryTableBody"] = "bets-history-table-body";
    ETestData["TestFixedHeaderMenu"] = "fixed-header-menu";
    ETestData["TestFixedHeaderAdditionalSupport"] = "fixed-header-additional-support";
    ETestData["TestFixedHeaderAdditionalRules"] = "fixed-header-additional-rules";
    ETestData["TestFixedHeaderAdditionalLanguage"] = "fixed-header-additional-language";
    ETestData["TestFixedHeaderAdditionalSetting"] = "fixed-header-additional-setting";
    ETestData["TestMainHeaderMenu"] = "main-header-menu";
    ETestData["TestMainHeaderLogo"] = "main-header-logo";
    ETestData["TestMainHeaderBetsHistoryButton"] = "main-header-bets-history-button";
    ETestData["TestMainHeaderFavouriteButton"] = "main-header-favourite-button";
    ETestData["TestMainHeaderNotificationsButton"] = "main-header-notifications-button";
    ETestData["TestMainHeaderBonusCouponButton"] = "main-header-bonus-coupon-button";
    ETestData["TestMainHeaderUserAccountBonus"] = "main-header-user-account-bonus";
    ETestData["TestMainHeaderUserAccountBalance"] = "main-header-user-account-balance";
    ETestData["TestMainHeaderIconPersonal"] = "main-header-icon-personal";
    ETestData["TestSearchInput"] = "search-input";
    ETestData["TestSearchIcon"] = "search-input";
    ETestData["TestSportsMenuTabLine"] = "sports-menu-tab-line";
    ETestData["TestSportsMenuTabLive"] = "sports-menu-tab-live";
    ETestData["TestLineTable"] = "line-table";
    ETestData["TestLiveTable"] = "live-table";
    ETestData["TestEventBetsButtonBack"] = "event-bets-button-back";
    ETestData["TestTournamentsSearchInput"] = "tournaments-sarch-input";
    ETestData["TestTableEventBets"] = "table-event-bets";
    ETestData["TestTableEventBetsGroup"] = "table-event-bets-group";
    ETestData["TestSponsorsItem"] = "sponsors-item";
    ETestData["TestBottomMenuLineLink"] = "bottom-menu-line-link";
    ETestData["TestBottomMenuLiveLink"] = "bottom-menu-live-link";
    ETestData["TestBottomMenuBetsLink"] = "bottom-menu-bets-link";
    ETestData["TestBottomMenuResultsLink"] = "bottom-menu-results-link";
    ETestData["TestBottomMenuProfileLink"] = "bottom-menu-profile-link";
    ETestData["TestTotalBetSizeInput"] = "total-bet-size-input";
    ETestData["TestCloseSettingsBasket"] = "close-settings-basket";
    ETestData["TestWinSumBasket"] = "win-sum-basket";
    ETestData["TestIconDependentOutcomes"] = "icon-dependent-outcomes";
    ETestData["TestBasketButton"] = "basket-button";
    ETestData["TestTopUpButton"] = "top-up-button";
    ETestData["TestProfileMenuItem"] = "profile-menu-item";
    ETestData["TestProfileButtonExit"] = "profile-button-exit";
    ETestData["TestProfileOpenVerificationForm"] = "profile-open-verification-form";
    ETestData["TestVerificationFormInput"] = "verification-form-item";
    ETestData["TestVerificationFormContinue"] = "verification-form-continue";
    ETestData["TestVerificationFormCheckbox"] = "verification-form-checkbox";
    ETestData["TestFullRegistrationButton"] = "full-registration-button";
    ETestData["TestVerificationFormCloseSuccessfulModal"] = "verification-form-close-successful-modal";
    ETestData["TestEventTable"] = "event-table";
    ETestData["TestFavoritesClearAll"] = "favorites-clear-all-button";
    ETestData["TestFavoritesTabs"] = "favorites-tabs";
    ETestData["TestEventTabAll"] = "event-tab-all";
    ETestData["TestEventTab"] = "event-tab";
    ETestData["TestEventFilterCollapseAll"] = "event-filter-collapse-all";
    ETestData["TestEventInputSearch"] = "event-input-search";
    ETestData["TestEventRowFilterCollapseAll"] = "event-row-filter-collapse-all";
    ETestData["TestEventRowFilterExpandAll"] = "event-row-filter-expand-all";
    ETestData["TestEventRowInputSearch"] = "event-row-input-search";
    ETestData["TestEventIconMagnifier"] = "event-icon-magnifier";
    ETestData["TestEventIconStarButton"] = "event-icon-star-button";
    ETestData["TestEventCanceled"] = "event-canceled";
    ETestData["TestEventComing"] = "event-coming";
    ETestData["TestEventOutcomesComing"] = "event-outcomes-coming";
    ETestData["TestEventPostponed"] = "event-postponed";
    ETestData["TestEventInterrupted"] = "event-interrupted";
    ETestData["TestEventStatisticsNotAvailable"] = "statistics-not-available";
    ETestData["TestSearchSearchHasNotGivenAnyResults"] = "search-search-has-not-given-any-results";
    ETestData["TestBetsHistory"] = "bets-history";
    ETestData["TestNoBets"] = "no-bets";
    ETestData["TestEmptyBasketTextSignIn"] = "empty-basket-text-sign-in";
    ETestData["TestEmptyBasketTextFastSignUp"] = "empty-basket-text-fast-sign-up";
    ETestData["TestBetStatusSuccessTitle"] = "bet-status-success-title";
    ETestData["TestBasketErrorText"] = "basket-error-text";
    ETestData["TestCouponEmpty"] = "coupon-empty";
    ETestData["TestCouponTubsButton"] = "cupon-tubs-button";
    ETestData["TestCouponAllHistory"] = "cupon-all-history";
    ETestData["TestBetInputExpress"] = "bet-input-express";
    ETestData["TestBetInputSystem"] = "bet-input-system";
    ETestData["TestSuccessAuthText"] = "success-auth-text";
    ETestData["TestRegistrationCompleted"] = "registration-completed";
    ETestData["TestLineTopButton"] = "line-top-button";
    ETestData["TestLiveTopButton"] = "live-top-button";
    ETestData["TestTopButton"] = "top-button";
    ETestData["TestPageTitle"] = "page-title";
    ETestData["TestTableCalendar"] = "table-calendar";
    ETestData["TestBasketBodyList"] = "basket-body-list";
    ETestData["TestLineTopTournament"] = "line-top-tournament";
    ETestData["TestLineTournament"] = "line-tournament";
    ETestData["TestSportsMenuList"] = "sports-menu-list";
    ETestData["TestSportsMenuItem"] = "sports-menu-item";
    ETestData["TestLoaderEventPending"] = "loader-event-pending";
    ETestData["TestRowLoaderEventPending"] = "row-loader-event-pending";
    ETestData["TestBasketEventEnded"] = "basket-event-ended";
    ETestData["TestBasketEventCanceled"] = "basket-event-canceled";
    ETestData["TestBasketEventSuspended"] = "basket-event-suspended";
    ETestData["TestBasketEventPostponed"] = "basket-event-postponed";
    ETestData["TestBasketEventInterrupted"] = "basket-event-interrupted";
    ETestData["TestBasketOutcomeNotAvailable"] = "basket-outcome-not-available";
    ETestData["TestBasketHistoryBody"] = "basket-history-body";
    ETestData["TestIconButtonBackHeader"] = "icon-button-back-header";
    ETestData["TestToastifyCancelButton"] = "toastify-cancel-button";
    ETestData["TestCashoutNotificationSold"] = "cashout-notification-sold";
    ETestData["TestHistoryBetType"] = "history-bet-type";
    ETestData["TestPopUpNotificationSuccessLogin"] = "pop-up-notification-success-login";
    ETestData["TestTitleUpcoming"] = "title-upcoming";
    ETestData["TestTitleGeneral"] = "general";
    ETestData["TestTitleGeneralAboutUs"] = "general-about-us";
    ETestData["TestFooter"] = "footer";
    ETestData["TestFooterAboutUs"] = "footer-about-us";
    ETestData["TestLineSelectPeriod"] = "line-select-period";
    ETestData["TestNothingFound"] = "nothing-found";
    ETestData["TestResetFilter"] = "reset-filter";
    ETestData["TestEventBannerWrapper"] = "event-banner-wrapper";
    ETestData["TestChangeUserPassword"] = "change-user-password";
    ETestData["TestUpdatePasswordButton"] = "update-password-button";
    ETestData["TestPasswordUpdatedSuccessfullyClose"] = "password-updated-successfully-close";
    ETestData["TestPasswordUpdatedSuccessfully"] = "password-updated-successfully";
    ETestData["TestBackToProfile"] = "back-to-profile";
    ETestData["TestChangePasswordError"] = "change-password-error";
    ETestData["TestPasswordConditionalIncorrect"] = "password-conditional-incorrect";
    ETestData["TestEventRowFavorite"] = "event-row-favorite";
    ETestData["TestMainPage"] = "main-page";
    ETestData["TestMainPageEventsControlLeft"] = "main-page-events-controls-left";
    ETestData["TestMainPageEventsControlRight"] = "main-page-events-control-right";
    ETestData["TestHeaderWrapper"] = "header-wrapper";
    ETestData["TestErrorMessage"] = "error-message";
    ETestData["TestFullRegistrationWrapperTwo"] = "full-registration-wrapper-two";
    ETestData["TestSettingsClose"] = "settings-close";
    ETestData["TestSettingsCheckbox"] = "settings-checkbox";
    ETestData["TestSettingsSwitch"] = "settings-switch";
    ETestData["TestSettingsLight"] = "settings-light";
    ETestData["TestSettingsDark"] = "settings-dark";
    ETestData["TestSettingsLine"] = "settings-line";
    ETestData["TestSettingsLive"] = "settings-live";
    ETestData["TestQuickBetSwitch"] = "quick-bet-switch";
    ETestData["TestQuickBetSaveAny"] = "quick-bet-save-any";
    ETestData["TestQuickBetInput"] = "quick-bet-input";
    ETestData["TestQuickBetInputValidationText"] = "quick-bet-input-validation-text";
    ETestData["TestQuickBetInputValidationWarning"] = "quick-bet-input-validation-warning";
    ETestData["TestQuickBetSaveSum"] = "quick-bet-save-sum";
    ETestData["TestQuickBetModalTitle"] = "quick-bet-modal-title";
    ETestData["TestQuickBetModalConfirmButton"] = "quick-bet-confirm-button";
    ETestData["TestQuickBetModalMakeBetButton"] = "quick-bet-make-bet-button";
    ETestData["TestQuickBetModalCloseButton"] = "quick-bet-close-button";
    ETestData["TestQuickBetConfirmCheckBox"] = "quick-bet-confirm-check-box";
    ETestData["TestQuickBetNotification"] = "quick-bet-notification";
    ETestData["TestQuickBetNotificationPending"] = "quick-bet-notification-pending";
    ETestData["TestQuickBetNotificationError"] = "quick-bet-notification-error";
    ETestData["TestQuickBetNotificationSuccess"] = "quick-bet-notification-success";
    ETestData["TestQuickBetNotificationActive"] = "quick-bet-notification-active";
    ETestData["TestQuickBetNotificationSumUpdated"] = "quick-bet-notification-sum-updated";
    ETestData["TestQuickBetClearBasketTitle"] = "quick-bet-clear-basket-title";
    ETestData["TestQuickBetClearBasketConfirm"] = "quick-bet-clear-basket-confirm";
    ETestData["TestQuickBetClearBasketCancel"] = "quick-bet-clear-basket-cancel";
    ETestData["TestQuickBetButton"] = "quick-bet-button";
    ETestData["TestProfileBalanceTab"] = "profile-balance-tab";
    ETestData["TestProfileBalanceWithdrawal"] = "profile-balance-withdrawal";
    ETestData["TestProfileBalanceWithdrawalFinance"] = "profile-balance-withdrawal-finance";
    ETestData["TestProfileBalanceWithdrawalMethod"] = "profile-balance-withdrawal-method";
    ETestData["TestNotificationText"] = "notification-text";
    ETestData["TestNotificationLink"] = "notification-link";
    ETestData["TestBetsHistoryCashoutButton"] = "bets-history-cashout-button";
    ETestData["TestBetsHistoryCashoutModalText"] = "bets-history-cashout-modal-text";
    ETestData["TestBetsHistoryCashoutModalButton"] = "bets-history-cashout-modal-button";
})(ETestData || (exports.ETestData = ETestData = {}));
//# sourceMappingURL=testData.types.js.map